export interface StatusResponse {
  statusCode: number;
  error: boolean | null;
}
